'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeProductForm = exports.productFormAction = exports.PRODUCT_FORM = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.doInitializeProductForm = doInitializeProductForm;
exports.doSubmitProductForm = doSubmitProductForm;
exports.watchProductFormSagas = watchProductFormSagas;

var _reactRouterRedux = require('react-router-redux');

var _reduxForm = require('redux-form');

var _reduxFormSaga = require('redux-form-saga');

var _effects = require('redux-saga/effects');

var _selectors = require('redux/saga/selectors');

var _multitrack = require('helpers/multitrack');

var _object = require('helpers/object');

var ObjectUtil = _interopRequireWildcard(_object);

var _pathToPurchaseHelper = require('helpers/pathToPurchaseHelper');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doInitializeProductForm),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(doSubmitProductForm),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(watchProductFormSagas);

var PRODUCT_FORM = exports.PRODUCT_FORM = 'signup-card-product';
var productFormAction = exports.productFormAction = (0, _reduxFormSaga.createFormAction)(PRODUCT_FORM);

var initializeProductForm = exports.initializeProductForm = function initializeProductForm(hiddenFields) {
  return {
    type: 'INITIALIZE_' + PRODUCT_FORM,
    hiddenFields: hiddenFields
  };
};

function doInitializeProductForm(client, _ref) {
  var hiddenFields = _ref.hiddenFields;
  return _regenerator2.default.wrap(function doInitializeProductForm$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _reduxForm.initialize)(PRODUCT_FORM, ObjectUtil.pick(['productId', 'productType', 'resumeSignupLink'], hiddenFields)));

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function doSubmitProductForm(client, _ref2) {
  var form = _ref2.payload;
  return _regenerator2.default.wrap(function doSubmitProductForm$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.call)(_pathToPurchaseHelper.setActiveOfferId, form.productId);

        case 2:
          _context2.t0 = form.resumeSignupLink;

          if (!_context2.t0) {
            _context2.next = 7;
            break;
          }

          _context2.next = 6;
          return (0, _effects.select)(_selectors.isLoggedIn);

        case 6:
          _context2.t0 = _context2.sent;

        case 7:
          if (!_context2.t0) {
            _context2.next = 12;
            break;
          }

          _context2.next = 10;
          return (0, _effects.put)((0, _reactRouterRedux.push)(form.resumeSignupLink));

        case 10:
          _context2.next = 17;
          break;

        case 12:
          _context2.next = 14;
          return (0, _effects.call)(_multitrack.ga, 'Membership Purchase', 'Membership Purchase Product Selection');

        case 14:
          _context2.next = 16;
          return (0, _effects.put)(productFormAction.success(ObjectUtil.pick(['productId', 'productType'], form)));

        case 16:
          return _context2.abrupt('return', _context2.sent);

        case 17:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function watchProductFormSagas(client) {
  return _regenerator2.default.wrap(function watchProductFormSagas$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, initializeProductForm().type, doInitializeProductForm, client);

        case 2:
          _context3.next = 4;
          return (0, _effects.fork)(_effects.takeEvery, productFormAction.REQUEST, doSubmitProductForm, client);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}